import { useEffect, useState } from 'react';
import RoundIconBtn from '@/Components/RoundIconBtn';

export default function ThemeToggle({ className = '' }) {
    const [theme, setTheme] = useState('dark');

    useEffect(() => {
        // Init state from local storage or document class
        if (localStorage.theme === 'light' || (!('theme' in localStorage) && !document.documentElement.classList.contains('dark'))) {
            setTheme('light');
        } else {
            setTheme('dark');
        }
    }, []);

    const toggleTheme = () => {
        if (theme === 'dark') {
            setTheme('light');
            localStorage.theme = 'light';
            document.documentElement.classList.remove('dark');
        } else {
            setTheme('dark');
            localStorage.theme = 'dark';
            document.documentElement.classList.add('dark');
        }
    };

    return (
        <RoundIconBtn
            icon={theme === 'dark' ? 'light_mode' : 'dark_mode'}
            onClick={toggleTheme}
            className={`!text-primary ${className}`}
            title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        />
    );
}
